import { faArrowLeft, faCheck, faCircleXmark, faDeleteLeft, faDownload, faEye, faTrash, faUpload } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Autocomplete, Box, Button, Checkbox, CircularProgress, FormControl, FormControlLabel, Input, MenuItem, Radio, RadioGroup, Select, TextField } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import Page from '../../component/Page'
import { getBranchList, LocationList } from '../setting/services/settingApi'
import api from '../../api/api'
import { AGENT_CONFIG } from './config'
import { saveAs } from 'file-saver';
import Swal from 'sweetalert2'
import dayjs from 'dayjs'
import RequireField from '../../component/RequireField'
import useDebounce from '../../hook/useDebounce'
// import io from "socket.io-client";
// const socket = io('http://localhost:9898');
export default function ViewCustomer() {

    const dataEl = document.getElementById('data');

    const [smc, serSMC] = useState(null)
    const [TextSmc, setTextSMC] = useState('กรุณาเชื่อมต่อบัตรประชาชน')
    // socket.on('connect', function () {
    //     socket.emit('set-query', {
    //         query: [
    //             'cid',
    //             'name',
    //             'nameEn',
    //             'dob',
    //             'gender',
    //             'issuer',
    //             'issueDate',
    //             'expireDate',
    //             'address',
    //             'photo',
    //             'nhso',
    //             'laserId',
    //         ],
    //     });
    // });

    // socket.on('smc-data', function (data) {
    //     serSMC(data.data);
    //     setTextSMC('ดึงข้อมูลสำเร็จ');

    // });
    // socket.on('smc-error', function (data) {
    //     setTextSMC('ทำรายการขัดข้อง');

    // });
    // socket.on('smc-removed', function (data) {
    //     setTextSMC('ถอดบัตรประชาชน');

    // });
    // socket.on('smc-incorrect', function (data) {
    //     setTextSMC(data.description);

    // });
    // socket.on('smc-inserted', function (data) {
    //     setTextSMC('กำลังดึงข้อมูล...');

    // });
    const TypesFileCustomer = [
        {
            name: 'สำเนาบัตรประจำตัวประชาชน',
            value: 'IdCardFiles',
        },
        {
            name: 'เอกสารอื่นๆ',
            value: 'OtherFiles',
        },
    ]
    const { id } = useParams()
    const fileRef = useRef()
    const navigate = useNavigate()
    const [file, setFile] = useState([])

    const [searchParams, setSearchParams] = useSearchParams()
    let sAddress = searchParams.get('Address') || ''
    let sCitizenid = searchParams.get('Citizenid') || ''
    let sSex = searchParams.get('Sex') || ''
    let sTh_Firstname = searchParams.get('Th_Firstname') || ''
    let sTh_Lastname = searchParams.get('Th_Lastname') || ''
    let sTh_Prefix = searchParams.get('Th_Prefix') || ''
    let saddrAmphur = searchParams.get('addrAmphur') || ''
    let saddrHouseNo = searchParams.get('addrHouseNo') || ''
    let saddrLane = searchParams.get('addrLane') || ''
    let saddrProvince = searchParams.get('addrProvince') || ''
    let saddrRoad = searchParams.get('addrRoad') || ''
    let saddrTambol = searchParams.get('addrTambol') || ''
    let saddrVillageNo = searchParams.get('addrVillageNo') || ''
    let sbirthday = searchParams.get('birthday') || ''

    const [typesFileSelected, setTypesFileSelected] = useState(TypesFileCustomer[0].value)
    const { profile, loading } = useSelector(state => state.profile)
    const [loadingSubmit, setLoadingSubmit] = useState(false)
    const [loadingDownloadPDF, setLoadingDownloadPDF] = useState(false)
    const [branchs, setBranchs] = useState([])
    const [customerTypes, setCustomerTypes] = useState([])
    const [customerTypeNo, setCustomerTypeNo] = useState('CT01')
    const [BranchNo, setBranchsNo] = useState('')
    const [gender, setGender] = useState('นาย')
    const [textGender, setTextGender] = useState('นาย')
    const [customerFName, setCustomerFName] = useState('')
    const [customerFNameError, setCustomerFNameError] = useState(false)
    const [customerLName, setCustomerLName] = useState('')
    const [customerLNameError, setCustomerLNameError] = useState(false)
    const [nationalityId, setNationalityId] = useState('')
    const [nationalityIdError, setNationalityIdError] = useState(false)
    const [nationalityIdErrorText, setNationalityIdErrorText] = useState('')
    const [nationalityIdCheck, setNationalityIdCheck] = useState(false)
    const [nationalityIdApiCheck, setNationalityIdApiCheck] = useState(false)
    const [contactName, setContactName] = useState('')
    const [contactNameError, setContactNameError] = useState(false)
    const [email, setEmail] = useState('')
    const [tel, setTel] = useState('')
    const [telError, setTelError] = useState(false)
    const [fax, setFax] = useState('')
    const [houseNumber, setHouseNumber] = useState('')
    const [moo, setMoo] = useState('')
    const [alley, setAlley] = useState('')
    const [address, setAddress] = useState('')
    const [province, setProvince] = useState('')
    const [provinceError, setProvinceError] = useState(false)
    const [value, setValue] = useState({
        ProvinceName: '',
        DistrictName: '',
        SubDistrictName: '',
        Zipcode: ''
    })
    const [valueC, setValueC] = useState({
        ProvinceName: '',
        DistrictName: '',
        SubDistrictName: '',
        Zipcode: ''
    })
    const [district, setDistrict] = useState('')
    const [districtError, setDistrictError] = useState(false)
    const [subDistrict, setSubDistrict] = useState('')
    const [subDistrictError, setSubDistrictError] = useState(false)
    const [zipcode, setZipcode] = useState('')
    const [zipcodeError, setZipcodeError] = useState(false)
    const debouncedSearchP = useDebounce(province, 500)
    const debouncedSearchD = useDebounce(district, 500)
    const debouncedSearchSD = useDebounce(subDistrict, 500)
    const debouncedSearchZ = useDebounce(zipcode, 500)
    const [currentHouseNumber, setCurrentHouseNumber] = useState('')
    const [currentMoo, setCurrentMoo] = useState('')
    const [currentAlley, setCurrentAlley] = useState('')
    const [currentAddress, setCurrentAddress] = useState('')
    const [currentProvince, setCurrentProvince] = useState('')
    const [currentDistrict, setCurrentDistrict] = useState('')
    const [currentSubDistrict, setCurrentSubDistrict] = useState('')
    const [currentZipcode, setCurrentZipcode] = useState('')
    const debouncedSearchPC = useDebounce(currentProvince, 500)
    const debouncedSearchDC = useDebounce(currentDistrict, 500)
    const debouncedSearchSDC = useDebounce(currentSubDistrict, 500)
    const debouncedSearchZC = useDebounce(currentZipcode, 500)
    const [locations, setLocations] = useState([])
    const [locationsC, setLocationsC] = useState([])
    const [filesRemove, setFilesRemove] = useState([])

    const [detail, setDetail] = useState()
    function Script_checkID(id) {
        if (id.substring(0, 1) == 0) return false;
        if (id.length != 13) return false;
        let sum = 0
        for (let i = 0; i < 12; i++)
            sum += parseFloat(id.charAt(i)) * (13 - i);
        if ((11 - sum % 11) % 10 != parseFloat(id.charAt(12))) return false;
        return true;
    }
    async function getNationality(id) {

        const res = await api.get('nationality-id' + `?id=${id}`)
        const data = res.data
        if (data.code === 2000 || data.code === 2001) {
            setNationalityIdApiCheck(true);
            if (!textGender) {
                setTextGender(data.result?.titleName)
                setGender(data.result?.titleName !== 'นาย' && data.result?.titleName !== 'นาง' && data.result?.titleName !== 'นางสาว' ? 'อื่นๆ' : data.result?.titleName)
            }
            if (!customerFName) {
                setCustomerFName(data.result?.firstName)
            }
            if (!customerLName) {
                setCustomerLName(data.result?.lastName)
            }
            if (!value?.ProvinceName) {
                setValue({
                    ProvinceName: data.result?.provinceDesc,
                    DistrictName: data.result?.districtDesc,
                    SubDistrictName: data.result?.subdistrictDesc,
                    Zipcode: data.result?.zipCode || ''
                })
            }
            if (!address) {
                setAddress(data.result?.roadDesc)
            }
            if (!alley) {
                setAlley(data.result?.alleyDesc)
            }
            if (!houseNumber) {
                setHouseNumber(data.result?.houseNo)
            }
            if (!moo) {
                setMoo(data.result?.villageNo)
            }

        } else {
            setNationalityIdApiCheck(false)
        }
    }
    async function getNationality2(id) {

        const res = await api.get('nationality-id' + `?id=${id}`)
        const data = res.data
        if (data.code === 2000 || data.code === 2001) {
            setNationalityIdApiCheck(true);
          
        } else {
            setNationalityIdApiCheck(false)
        }
    }

    const getPathImage = (extension) => {
        if (extension === 'png') {
            return 'assets/icons/png.svg';
        }
        else if (extension === 'jpg') {
            return 'assets/icons/jpg.svg';
        }
        else if (extension === 'pdf') {
            return 'assets/icons/pdf.svg';
        }
        else if (extension === 'doc') {
            return 'assets/icons/doc.svg';
        }
        else if (extension === 'txt') {
            return 'assets/icons/txt.svg';
        }
        else if (extension === 'zip') {
            return 'assets/icons/zip.svg';
        }
        else if (extension === 'xls' || extension === 'xlsx') {
            return 'assets/icons/xls.svg';
        }
        else {
            return 'assets/icons/file.svg';
        }

    }
    async function getCustomerTypes() {

        const res = await api.get(AGENT_CONFIG.requests.getCustomerTypes.url)
        const data = res.data
        if (data.status === true) {
            const types = data.result.length > 0 ? data.result.filter(x => x.CustomerTypeNo !== 'CT05' && x.CustomerTypeNo !== 'CT00') : [];

            setCustomerTypes(types)
        }
    }
    const getCustomerDetail = async () => {
        const url = AGENT_CONFIG.requests.getCustomers.url + `/${id}`;
        const res = await api.get(url)
        const data = res.data
        if (data.status === true) {
            setDetail(data.result)
            setBranchsNo(data.result?.BranchNo)
            setCustomerTypeNo(data.result?.CustomerTypeNo?.CustomerTypeNo)
            setTextGender(data.result?.Title)
            setGender(data.result?.Title !== 'นาย' && data.result?.Title !== 'นาง' && data.result?.Title !== 'นางสาว' ? 'อื่นๆ' : data.result?.Title)
            setCustomerFName(data.result?.CustomerFName)
            setCustomerLName(data.result?.CustomerLName)
            setContactName(data.result?.ContactName)
            setNationalityId(data.result?.NationalityId)
            if (data.result?.NationalityId.length === 13) {
                if (Script_checkID(data.result?.NationalityId)) {
                    setNationalityIdCheck(true)
                    // setTimeout(() => {
                        getNationality2(data.result?.NationalityId)

                    // }, 5000);
                }
            }
            setEmail(data.result?.Email)
            setTel(data.result?.Tel)
            setFax(data.result?.Fax)
            setAddress(data.result?.Address)
            setAlley(data.result?.Alley)
            setHouseNumber(data.result?.HouseNumber)
            setMoo(data.result?.Moo)
            setValue({
                ProvinceName: data.result?.Province,
                DistrictName: data.result?.District,
                SubDistrictName: data.result?.SubDistrict,
                Zipcode: data.result?.Zipcode
            })
            setCurrentAddress(data.result?.CurrentAddress)
            setCurrentAlley(data.result?.CurrentAlley)
            setCurrentHouseNumber(data.result?.CurrentHouseNumber)
            setCurrentMoo(data.result?.CurrentMoo)
            setValueC({
                ProvinceName: data.result?.CurrentProvince,
                DistrictName: data.result?.CurrentDistrict,
                SubDistrictName: data.result?.CurrentSubDistrict,
                Zipcode: data.result?.CurrentZipcode
            })
            let files = []
            if (data?.result?.Files.length > 0) {
                const _file = data?.result?.Files
                _file.forEach(x => {
                    x.typeFile = x.FileName.split('.')?.pop();
                    const type = TypesFileCustomer.find(c => c.value === x.FileType);
                    x.typeDoc = type?.name;
                    x.pathImg = getPathImage(x.typeFile);
                    x.isNew = false;
                })
                files = _file;
            }
            setFile([...files])
        }
    }
    useEffect(() => {
        if (id) {
            getCustomerDetail()
        }
        getBranchList(null, setBranchs)
        getCustomerTypes()
        const body = {
            typeSearch: '',
            Text: ''
        };
        LocationList(body, setLocations)
        LocationList(body, setLocationsC)
        if (!id) {
            if (sTh_Prefix) {
                setTextGender(sTh_Prefix === 'น.ส.' ? 'นางสาว' : sTh_Prefix)
                setGender(sTh_Prefix !== 'นาย' && sTh_Prefix !== 'นาง' && sTh_Prefix !== 'น.ส.' ? 'อื่นๆ' : sTh_Prefix === 'น.ส.' ? 'นางสาว' : sTh_Prefix)
            }
            if (sTh_Firstname) {
                setCustomerFName(sTh_Firstname)
            }
            if (sTh_Lastname) {
                setCustomerLName(sTh_Lastname)
            }
            setContactName(sTh_Firstname && sTh_Lastname ? `${sTh_Firstname} ${sTh_Lastname}` : '')
            if (sCitizenid) {
                setNationalityId(sCitizenid)
            }
            let newsaddrAmphur = saddrAmphur
            let newsaddrTambol = saddrTambol
            setValue({
                ProvinceName: saddrProvince && (saddrProvince?.startsWith('จังหวัด') ? saddrProvince.slice('จังหวัด'.length) : saddrProvince),
                DistrictName: saddrAmphur && (saddrAmphur?.startsWith('อำเภอ') ? newsaddrAmphur.slice('อำเภอ'.length) : saddrAmphur?.startsWith('เขต') ? newsaddrAmphur.slice('เขต'.length) : saddrAmphur),
                SubDistrictName: saddrTambol && (saddrTambol?.startsWith('ตำบล') ? newsaddrTambol.slice('ตำบล'.length) : saddrTambol?.startsWith('แขวง') ? newsaddrTambol.slice('แขวง'.length) : saddrTambol),
                Zipcode: ''
            })
            if (saddrHouseNo) {
                setHouseNumber(saddrHouseNo)
            }
            if (saddrVillageNo) {
                setMoo(saddrVillageNo && (saddrVillageNo?.startsWith('หมู่ที่ ') ? saddrVillageNo.slice('หมู่ที่ '.length) : saddrVillageNo?.startsWith('หมู่ที่') ? saddrVillageNo.slice('หมู่ที่'.length) : saddrVillageNo))
            }
        }

    }, [])
    useEffect(() => {
        if (profile) {
            setBranchsNo(profile?.BranchNo?.BranchNo)
        }
    }, [profile])

    useEffect(() => {
        if (debouncedSearchP.length >= 0) {
            const body = {
                typeSearch: 'P',
                Text: debouncedSearchP
            };
            LocationList(body, setLocations)
        }
        if (debouncedSearchD.length >= 0) {
            const body = {
                typeSearch: 'D',
                Text: debouncedSearchD
            };
            LocationList(body, setLocations)
        }
        if (debouncedSearchSD.length >= 0) {
            const body = {
                typeSearch: 'SD',
                Text: debouncedSearchSD
            };
            LocationList(body, setLocations)
        }
        if (debouncedSearchZ.length >= 0) {
            const body = {
                typeSearch: 'Z',
                Text: debouncedSearchZ
            };
            LocationList(body, setLocations)
        }
    }, [debouncedSearchP, debouncedSearchD, debouncedSearchSD, debouncedSearchZ])
    useEffect(() => {
        if (currentProvince.length >= 0) {
            const body = {
                typeSearch: 'P',
                Text: currentProvince
            };
            LocationList(body, setLocationsC)
        }
        if (currentDistrict.length >= 0) {
            const body = {
                typeSearch: 'D',
                Text: currentDistrict
            };
            LocationList(body, setLocationsC)
        }
        if (currentSubDistrict.length >= 0) {
            const body = {
                typeSearch: 'SD',
                Text: currentSubDistrict
            };
            LocationList(body, setLocationsC)
        }
        if (currentZipcode.length >= 0) {
            const body = {
                typeSearch: 'Z',
                Text: currentZipcode
            };
            LocationList(body, setLocationsC)
        }
    }, [debouncedSearchPC, debouncedSearchDC, debouncedSearchSDC, debouncedSearchZC])




    async function downloadCustomerInfo() {
        setLoadingDownloadPDF(true)
        const res = await api.get(AGENT_CONFIG.requests.getCustomers.url + `/${id}/pdf`, {
            params: '',
            responseType: 'arraybuffer'
        })
        const buffer = res.data
        const blob = new Blob([buffer], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        window.open(url, '_blank');
        setLoadingDownloadPDF(false)

    }


    //   async function downloadFile(file) {

    //     const res = await this.agentService.GetFileDownload(file?.UploadFileId);
    //     const blob = new Blob([res]);
    //     saveAs(blob, file?.FileName);

    //   }

    //   async function FremoveFiles(fileRemove) {
    //     await this.agentService.RemoveFiles(fileRemove);
    //   }

    async function uploadFile(event) {
        if (event.target.files && event.target.files?.length) {
            const files = event.target.files[0];
            const extension = files.name.split('.')?.pop();
            const pathImg = getPathImage(extension);
            const type = TypesFileCustomer.find(c => c.value === typesFileSelected);
            const fileUpload = {
                Category: 'Agent',
                CategoryRefNo: null,
                FileName: files.name,
                FilePath: null,
                typeDoc: type.name,
                FileType: typesFileSelected,
                pathImg: pathImg,
                typeFile: extension,
                UploadFileId: null,
                File: files,
                isNew: true
            }

            // files.push(fileUpload);
            setFile([...file, fileUpload])
            event.target.value = null
        }
    }

    const handleSubmit = async (status) => {

        // if (this.form.invalid) {
        //     return this.form.markAllAsTouched();
        // }
        // if (this.form.get('CustomerTypeNo').value === 'CT06' || this.form.get('CustomerTypeNo').value === 'CT01') {
        //     if (this.selectTitle === null) {

        //         return;
        //     }
        // }


        // if (status === StockStatus.Inactive) {
        //     const confirm = await this.alertService.confirm('ยืนยันการยกเลิก');
        //     if (!confirm) {
        //         return;
        //     }
        // }
        setLoadingSubmit(true)
        const frmData = new FormData();
        const addFiles = file.length > 0 ? file.filter(x => x.isNew) : [];
        // const fileRemove = this.filesRemove.length > 0 ? this.filesRemove : [];


        if (filesRemove.length > 0) {
            const _remove = {
                FileIDs: filesRemove
            }
            await FremoveFiles(_remove);
            setFilesRemove([]);
        }

        if (addFiles.length > 0) {
            for (const c of addFiles) {
                frmData.append(c?.FileType, c?.File);
            }
        }

        if (detail?.CustomerId) {
            frmData.append('CustomerId', detail?.CustomerId.toString());
        }

        if (id) {
            frmData.append('CustomerNo', id);
        }

        if (customerTypeNo === 'CT06' || customerTypeNo === 'CT01') {
            frmData.append('Title', textGender);
        } else {
            frmData.append('Title', '');
        }

        frmData.append('BranchNo', BranchNo);

        frmData.append('Email', email || '');


        frmData.append('CustomerFName', customerFName || '');

        frmData.append('CustomerLName', customerLName || '');


        if (customerTypeNo === 'CT06' || customerTypeNo === 'CT01') {
            const name = `${customerFName} ${customerLName}`;
            frmData.append('ContactName', name);
        } else {
            frmData.append('ContactName', contactName);
        }



        // if (this.form.get('BirthDate').value) {
        //   frmData.append('BirthDate', this.datePipe.transform(this.form.get('BirthDate').value, 'yyyy-MM-dd'));
        // }

        frmData.append('CustomerTypeNo', customerTypeNo);
        if (nationalityId) {
            frmData.append('NationalityId', nationalityId);
        }


        if (moo) {
            frmData.append('Moo', moo);
        }

        if (address) {
            frmData.append('Address', address);
        }

        if (houseNumber) {
            frmData.append('HouseNumber', houseNumber);
        }

        if (currentAlley) {
            frmData.append('CurrentAlley', currentAlley);
        }
        if (alley) {
            frmData.append('Alley', alley);
        }


        frmData.append('Province', value.ProvinceName);
        frmData.append('District', value.DistrictName);
        frmData.append('SubDistrict', value.SubDistrictName);
        frmData.append('Zipcode', value.Zipcode);

        if (currentHouseNumber) {
            frmData.append('CurrentHouseNumber', currentHouseNumber);
        }
        if (currentMoo) {
            frmData.append('CurrentMoo', currentMoo);
        }
        if (currentAddress) {
            frmData.append('CurrentAddress', currentAddress);
        }

        frmData.append('CurrentProvince', valueC.ProvinceName);
        frmData.append('CurrentDistrict', valueC.DistrictName);
        frmData.append('CurrentSubDistrict', valueC.SubDistrictName);
        frmData.append('CurrentZipcode', valueC.Zipcode);

        frmData.append('Tel', tel);
        if (fax) {
            frmData.append('Fax', fax);
        }

        const _Status = detail && detail?.Status === 'Y' ? 'Y' : status;
        frmData.append('Status', _Status);
        if (id) {
            const url = AGENT_CONFIG.requests.getCustomers.url + `/${id}`;
            const res = await api.put(url, frmData)
            const data = res.data
            if (data.status === true) {
                getCustomerDetail()
                Swal.fire(
                    'ทำรายการสำเร็จ',
                    '',
                    'success'
                )
            } else {
                Swal.fire({
                    title: data?.message || data?.code === 2003 ? 'บันทึกข้อมูลไม่สำเร็จ มีข้อมูลนี้ในระบบแล้ว' : 'ทำรายการไม่สำเร็จ',
                    icon: 'warning',
                })
            }
        } else {

            const res = await api.post(AGENT_CONFIG.requests.getCustomers.url, frmData)
            const data = res.data
            if (data.status === true) {
                navigate('/agent/customer-list/' + data.result.CustomerNo)

                Swal.fire(
                    'ทำรายการสำเร็จ',
                    '',
                    'success'
                )
            } else {
                Swal.fire({
                    title: data?.message || data?.code === 2003 ? 'บันทึกข้อมูลไม่สำเร็จ มีข้อมูลนี้ในระบบแล้ว' : 'ทำรายการไม่สำเร็จ',
                    icon: 'warning',
                })

            }
        }

        setLoadingSubmit(false)

    }
    async function downloadFile(file) {
        const url = AGENT_CONFIG.requests.downloadFile.url + `/${file?.UploadFileId}`;
        const res = await api.get(url, {
            responseType: 'arraybuffer'
        })
        const blob = new Blob([res.data]);
        saveAs(blob, file?.FileName);

    }

    async function viewFile(file) {
        const url = AGENT_CONFIG.requests.downloadFile.url + `/${file?.UploadFileId}`;
        const res = await api.get(url, {
            responseType: 'arraybuffer'
        })
        if (file?.typeFile === 'jpeg') {
            const blob = new Blob([res.data], { type: `image/${file?.typeFile}` });
            const blobUrl = URL.createObjectURL(blob);

            window.open(blobUrl, '_blank');
        }
        else if (file?.typeFile === 'jpg') {
            const blob = new Blob([res.data], { type: `image/${file?.typeFile}` });
            const blobUrl = URL.createObjectURL(blob);

            window.open(blobUrl, '_blank');
        }
        else if (file?.typeFile === 'png') {
            const blob = new Blob([res.data], { type: `image/${file?.typeFile}` });
            const blobUrl = URL.createObjectURL(blob);

            window.open(blobUrl, '_blank');
        }

        else if (file?.typeFile === 'pdf') {
            const blob = new Blob([res.data], { type: `application/pdf` });
            const blobUrl = URL.createObjectURL(blob);

            window.open(blobUrl, '_blank');
        } else {
            const blob = new Blob([res.data]);
            saveAs(blob, file?.FileName);
        }
        // saveAs(blob, file?.FileName);

    }

    async function FremoveFiles(fileRemove) {

        const res = await api.put(AGENT_CONFIG.requests.removeFiles.url, fileRemove)
    }
    const handleSMC = () => {
        if (smc) {
            setCustomerFName(smc?.name?.firstname)
            setCustomerLName(smc?.name?.lastname)
            setNationalityId(smc?.cid)
            if (smc?.cid.length === 13) {
                if (Script_checkID(smc?.cid)) {
                    setNationalityIdCheck(true)
                    getNationality(smc?.cid)
                }
            }
            setTextGender(smc?.name?.prefix)
            setGender(smc?.name?.prefix !== 'นาย' && smc?.name?.prefix !== 'นาง' && smc?.name?.prefix !== 'นางสาว' ? 'อื่นๆ' : smc?.name?.prefix)
            setAddress(smc?.address?.street)
            setAlley(smc?.address?.soi)
            setHouseNumber(smc?.address?.houseNo)
            setMoo(smc?.address?.moo)
            setValue({
                ProvinceName: smc?.address?.province,
                DistrictName: smc?.address?.district,
                SubDistrictName: smc?.address?.subdistrict,
                Zipcode: ''
            })
            setTextSMC('กรุณาเชื่อมต่อบัตรประชาชน')
            serSMC(null)
        }
    }

    return (
        <div style={{ padding: '10px 30px' }}>
            <Page>
                <form >
                    <div class="card-content mt-4">
                        <div class="container-fluid">
                            <div class="d-flex row align-items-center ">
                                <div class="col-6">

                                    <label class="title-content mb-4 me-4">
                                        ข้อมูลลูกค้า
                                    </label>

                                </div>
                                {id &&
                                    <div class="col-6 text-end px-4">
                                        <Button type="button" className="ButtomSearch" sx={{
                                            width: '110px',
                                            background: '#3364af57 0 0 no-repeat padding-box',
                                            border: '1px solid #3364af57',
                                            color: '#3364af',
                                            fontWeight: '700',
                                            borderRadius: '100px', ':hover': {
                                                background: '#3364af57 0 0 no-repeat padding-box',
                                            }
                                        }} variant='contained' onClick={downloadCustomerInfo}>{loadingDownloadPDF ? <CircularProgress size={'18px'} color="inherit" /> : 'พิมพ์'}</Button>
                                    </div>}
                                {/* <div style={{ display: 'flex', alignItems: "center", marginBottom: "20px" }}>
                                    <p id="data" style={{ fontSize: "16px", marginRight: "20px", marginBottom: '0px' }}>{TextSmc}</p>
                                    <Button variant='contained' disabled={TextSmc !== 'ดึงข้อมูลสำเร็จ'} onClick={() => handleSMC()}>ดึงข้อมูลจากบัตรประชาชน</Button>
                                </div> */}


                            </div>
                            {id &&
                                <>
                                    <div class="row" >
                                        <div class="col-lg-4 col-md-6">
                                            <label class="labelInput me-3">ผู้สร้าง</label> <label class="message-error-label">( {dayjs(detail?.CreateDate).format('DD/MM/BBBB')} )</label>
                                            <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                                <TextField disabled value={detail?.CreateId} variant="standard" fullWidth
                                                    InputProps={{
                                                        disableUnderline: true,
                                                    }}
                                                />
                                            </Box>
                                        </div>
                                        <div class="col-lg-4 col-md-6">
                                            <label class="labelInput me-3">ผู้แก้ไข</label> <label class="message-error-label">( {dayjs(detail?.ModifiedDate).format('DD/MM/BBBB')} )</label>
                                            <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                                <TextField disabled value={detail?.ModifiedId} variant="standard" fullWidth
                                                    InputProps={{
                                                        disableUnderline: true,
                                                    }}
                                                />
                                            </Box>
                                        </div>
                                    </div >
                                    <div class="row">
                                        <div class="col-lg-8 col-md-12">

                                            <label class="labelInput">รหัสลูกค้า</label>
                                            <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                                <TextField disabled value={id} variant="standard" fullWidth
                                                    InputProps={{
                                                        disableUnderline: true,
                                                    }}
                                                />
                                            </Box>

                                        </div>
                                    </div>
                                </>
                            }

                            <div class="row">

                                <div class="col-lg-4 col-md-12">
                                    <label class="labelInput">ประเภทลูกค้า</label>
                                    <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                        <FormControl variant="standard" fullWidth >
                                            <Select value={customerTypeNo || ''} onChange={e => {
                                                setCustomerTypeNo(e.target.value)
                                                if (e.target.value === "CT02" || e.target.value === 'CT03' || e.target.value === 'CT04') {
                                                    setContactName('')
                                                    setCustomerFName('')
                                                    setCustomerLName('')
                                                    setNationalityId('')
                                                    setFax('')
                                                    setEmail('')
                                                    setTel('')
                                                }
                                            }} disableUnderline >
                                                {customerTypes?.map((x) => (
                                                    <MenuItem value={x?.CustomerTypeNo}>{x?.TypeName}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Box>

                                </div>
                                <div class="col-lg-4 col-md-12">
                                    <label class="labelInput">ศูนย์เมล็ดพันธุ์ข้าว</label>
                                    <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                        <FormControl variant="standard" fullWidth >
                                            <Select value={BranchNo || ''} onChange={e => setBranchsNo(e.target.value)} disableUnderline >
                                                {branchs?.map((x) => (
                                                    <MenuItem value={x?.BranchNo}>{x?.BranchName}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Box>

                                </div>


                            </div>
                            {customerTypeNo === 'CT06' || customerTypeNo === 'CT01' ?
                                <div class="row" style={{ alignItems: 'flex-end' }}>
                                    {gender === 'อื่นๆ' &&
                                        <div class="col-lg-2 col-md-12">
                                            <label class="labelInput">คำหน้าอื่นๆ</label>
                                            <Box className='backgroundField'>
                                                <TextField value={textGender} onChange={e => setTextGender(e.target.value)} variant="standard" fullWidth
                                                    InputProps={{
                                                        disableUnderline: true,
                                                    }}
                                                />
                                            </Box>
                                        </div>}
                                    <div class={gender === 'อื่นๆ' ? 'col-lg-3 col-md-12' : 'col-lg-4 col-md-12'} >
                                        <div style={{ display: "flex", alignItems: "center" }}>
                                            <label class="labelInput me-4">ชื่อ </label>
                                            <FormControl>
                                                <RadioGroup row
                                                    value={gender}
                                                    onChange={e => {
                                                        setGender(e.target.value)
                                                        if (e.target.value === 'อื่นๆ') {
                                                            setTextGender('นาย')
                                                        } else {
                                                            setTextGender(e.target.value)
                                                        }
                                                    }}>
                                                    <FormControlLabel value="นาย" control={<Radio size="small" />} label="นาย" />
                                                    <FormControlLabel value="นาง" control={<Radio size="small" />} label="นาง" />
                                                    <FormControlLabel value="นางสาว" control={<Radio size="small" />} label="นางสาว" />
                                                    <FormControlLabel value="อื่นๆ" control={<Radio size="small" />} label="อื่นๆ" />
                                                </RadioGroup>
                                            </FormControl>
                                        </div>

                                        <RequireField value={customerFName} onChange={setCustomerFName} type={'text'} error={customerFNameError} setError={setCustomerFNameError} textError={'กรุณากรอกชื่อ'} />

                                    </div>
                                    <div class={gender === 'อื่นๆ' ? 'col-lg-3 col-md-12' : 'col-lg-4 col-md-12'} >
                                        <label class="labelInput">นามสกุล</label>

                                        <RequireField value={customerLName} onChange={setCustomerLName} type={'text'} error={customerLNameError} setError={setCustomerLNameError} textError={'กรุณากรอกนามสกุล'} />
                                    </div>

                                </div>
                                : ''
                            }



                            <div class="row">
                                {customerTypeNo === 'CT06' || customerTypeNo === 'CT01' ?
                                    <div class="col-lg-4 col-md-12">
                                        <label class="labelInput">บัตรประจำตัวประชาชน</label>
                                        <Box className={`backgroundField ${nationalityIdError ? 'error' : ''}`} >
                                            <TextField value={nationalityId} onChange={e => {
                                                if (e.target.value.length < 13) {
                                                    setNationalityId(e.target.value)
                                                }
                                                else {
                                                    if (Script_checkID(e.target.value)) {
                                                        setNationalityIdError(false)
                                                        setNationalityId(e.target.value)
                                                        setNationalityIdCheck(true)
                                                        getNationality(e.target.value)
                                                    }
                                                    else {
                                                        setNationalityIdError(true)
                                                        setNationalityIdErrorText('บัตรประจำตัวประชาชนไม่ถูกต้อง')
                                                        setNationalityId(e.target.value)
                                                        setNationalityIdCheck(false)
                                                    }
                                                }
                                            }
                                            } variant="standard" fullWidth
                                                onBlur={e => {
                                                    if (!e.target.value) {
                                                        setNationalityIdError(true)
                                                        setNationalityIdErrorText('กรุณากรอกบัตรประจำตัวประชาชน')
                                                        setNationalityIdCheck(false)
                                                    } else {
                                                        if (e.target.value.length < 13) {
                                                            setNationalityIdError(true)
                                                            setNationalityIdErrorText('กรุณากรอกให้ครบ 13 หลัก')
                                                            setNationalityIdCheck(false)
                                                        }
                                                        else {
                                                            if (Script_checkID(e.target.value)) {
                                                                setNationalityIdError(false)
                                                            }
                                                            else {
                                                                setNationalityIdError(true)
                                                                setNationalityIdErrorText('บัตรประจำตัวประชาชนไม่ถูกต้อง')
                                                                setNationalityIdCheck(false)
                                                            }
                                                        }

                                                    }
                                                }}
                                                InputProps={{
                                                    disableUnderline: true,
                                                }}
                                                inputProps={{ maxLength: 13 }}
                                                onKeyPress={(event) => {
                                                    if (!/[0-9]/.test(event.key)) {
                                                        event.preventDefault();
                                                    }
                                                }}
                                            />
                                            {nationalityIdCheck &&
                                                <div style={{ color: nationalityIdApiCheck ? '#fff' : "#f1f1f1", fontSize: "18px", background: nationalityIdApiCheck ? 'green' : '#bbbbbb', display: "flex", alignItems: "center", justifyContent: 'center', width: "32px", height: "32px", borderRadius: "50%" }}>
                                                    <FontAwesomeIcon icon={faCheck} />
                                                </div>}
                                        </Box>
                                        {nationalityIdError && <span style={{ color: 'red', fontSize: '12px', }}>{nationalityIdErrorText}</span>}
                                    </div> : <div class="col-lg-4 col-md-12">
                                        <label class="labelInput">ชื่อสถาบัน/กลุ่มเกษตรกร</label>
                                        <RequireField value={customerFName} onChange={setCustomerFName} type={'text'} error={customerFNameError} setError={setCustomerFNameError} textError={'กรุณากรอกชื่อสถาบัน/กลุ่มเกษตรกร'} />


                                    </div>}
                                <div class="col-lg-4 col-md-12">
                                    <label class="labelInput">อีเมล</label>
                                    <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                        <TextField value={email} onChange={e => setEmail(e.target.value)} variant="standard" fullWidth
                                            InputProps={{
                                                disableUnderline: true,
                                            }}
                                            onKeyPress={(event) => {
                                                if (!/[a-zA-Z0-9@._-]/.test(event.key)) {
                                                    event.preventDefault();
                                            }
                                        }}
                                        />
                                    </Box>
                                </div>
                            </div>


                            <div class="row">
                                <div class="col-lg-4 col-md-12">
                                    <label class="labelInput">โทรศัพท์</label>

                                    <RequireField value={tel} onChange={setTel} type={'number'} error={telError} setError={setTelError} textError={'กรุณากรอกเบอร์โทรศัพท์'} />


                                </div>
                                <div class="col-lg-4 col-md-12">
                                    <label class="labelInput">โทรสาร</label>
                                    <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                        <TextField value={fax} onChange={e => setFax(e.target.value)} variant="standard" fullWidth
                                            InputProps={{
                                                disableUnderline: true,
                                            }}
                                            onKeyPress={(event) => {
                                                if (!/[0-9]/.test(event.key)) {
                                                    event.preventDefault();
                                                }
                                            }}
                                        />
                                    </Box>
                                </div>

                            </div>
                            {customerTypeNo === 'CT06' || customerTypeNo === 'CT01' ? '' :
                                <div class="row">

                                    <div class="col-lg-4 col-md-12">
                                        <label class="labelInput">ชื่อผู้ติดต่อ</label>

                                        <RequireField value={contactName} onChange={setContactName} type={'text'} error={contactNameError} setError={setContactNameError} textError={'ชื่อหน่วยงาน'} />

                                    </div>
                                </div>}

                            <hr class="chr" />

                            <div class="d-flex row align-items-center ">
                                <div class="col-6">
                                    <label class="title-content mb-4">
                                        {customerTypeNo === 'CT01' || customerTypeNo === 'CT06' ? 'ที่อยู่ตามบัตรประชาชน' : customerTypeNo === 'CT02' || customerTypeNo === 'CT03' ? 'ที่อยู่หน่วยงาน' : 'ที่อยู่สถาบัน/กลุ่มเกษตรกร'}
                                    </label>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-lg-4 col-md-12">
                                    <label class="labelInput">บ้านเลขที่</label>

                                    <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                        <TextField value={houseNumber} onChange={e => setHouseNumber(e.target.value)} variant="standard" fullWidth
                                            InputProps={{
                                                disableUnderline: true,
                                            }}
                                        />
                                    </Box>
                                </div>
                                <div class="col-lg-4 col-md-12">
                                    <label class="labelInput">หมู่</label>
                                    <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                        <TextField value={moo} onChange={e => setMoo(e.target.value)} variant="standard" fullWidth
                                            InputProps={{
                                                disableUnderline: true,
                                            }}
                                            onKeyPress={(event) => {
                                                if (!/[0-9]/.test(event.key)) {
                                                    event.preventDefault();
                                                }
                                            }}
                                        />
                                    </Box>
                                </div>


                            </div>
                            <div class="row">
                                <div class="col-lg-4 col-md-12">
                                    <label class="labelInput">ตรอก/ซอย</label>
                                    <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                        <TextField value={alley} onChange={e => setAlley(e.target.value)} variant="standard" fullWidth
                                            InputProps={{
                                                disableUnderline: true,
                                            }}
                                        />
                                    </Box>
                                </div>
                                <div class="col-lg-4 col-md-12">
                                    <label class="labelInput">ถนน</label>
                                    <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                        <TextField value={address} onChange={e => setAddress(e.target.value)} variant="standard" fullWidth
                                            InputProps={{
                                                disableUnderline: true,
                                            }}
                                        />
                                    </Box>
                                </div>


                            </div>

                            <div class="row">

                                <div class="col-lg-4 col-md-12">
                                    <label class="labelInput">ตำบล</label>
                                    <Autocomplete
                                        fullWidth
                                        options={locations || []}
                                        getOptionLabel={(option) => option?.SubDistrictName}
                                        renderOption={(props, option) => (
                                            <Box component="li" {...props} key={option.SubDistrictId}>
                                                จ.{option?.ProvinceName} / อ.{option?.DistrictName} / ต.{option?.SubDistrictName} / {option?.Zipcode}
                                            </Box>
                                        )}
                                        loading={locations.length > 0}

                                        inputValue={subDistrict || ''}
                                        onInputChange={(event, newInputValue) => {
                                            setSubDistrict(newInputValue);
                                        }}
                                        value={value || null}
                                        onChange={(event, newValue) => {
                                            setValue(newValue)
                                            // setValueD(newValue)
                                        }}
                                        onBlur={e => {
                                            if (!e.target.value) {
                                                setSubDistrictError(true)
                                            } else {
                                                setSubDistrictError(false)
                                            }
                                        }}

                                        renderInput={(params) => (
                                            <Box className={`backgroundField ${subDistrict.length === 0 && subDistrictError ? 'error' : ''}`} ref={params.InputProps.ref}>
                                                <Input type="text" {...params.inputProps} disableUnderline />

                                            </Box>
                                        )} />
                                    {subDistrict.length === 0 && subDistrictError && <span style={{ color: 'red', fontSize: '12px', }}>กรุณากรอกตำบล</span>}

                                </div>
                                <div class="col-lg-4 col-md-12">
                                    <label class="labelInput">อำเภอ</label>
                                    <Autocomplete
                                        fullWidth
                                        options={locations || []}
                                        getOptionLabel={(option) => option?.DistrictName}
                                        renderOption={(props, option) => (
                                            <Box component="li" {...props} key={option.SubDistrictId}>
                                                จ.{option?.ProvinceName} / อ.{option?.DistrictName} / ต.{option?.SubDistrictName} / {option?.Zipcode}
                                            </Box>
                                        )}
                                        loading={locations.length > 0}
                                        inputValue={district || ''}
                                        onInputChange={(event, newInputValue) => {
                                            setDistrict(newInputValue);
                                        }}
                                        value={value || null}
                                        onChange={(event, newValue) => {
                                            setValue(newValue)
                                            // setValueD(newValue)
                                        }}
                                        onBlur={e => {
                                            if (!e.target.value) {
                                                setDistrictError(true)
                                            } else {
                                                setDistrictError(false)
                                            }
                                        }}
                                        renderInput={(params) => (
                                            <Box className={`backgroundField ${district.length === 0 && districtError ? 'error' : ''}`} ref={params.InputProps.ref}>
                                                <Input type="text" {...params.inputProps} disableUnderline />

                                            </Box>
                                        )}
                                    />
                                    {district.length === 0 && districtError && <span style={{ color: 'red', fontSize: '12px', }}>กรุณากรอกอำเภอ</span>}

                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-4 col-md-12">
                                    <label class="labelInput">จังหวัด</label>
                                    <Autocomplete
                                        fullWidth
                                        options={locations || []}
                                        getOptionLabel={(option) => option?.ProvinceName}
                                        renderOption={(props, option) => (
                                            <Box component="li" {...props} key={option.SubDistrictId}>
                                                จ.{option?.ProvinceName} / อ.{option?.DistrictName} / ต.{option?.SubDistrictName} / {option?.Zipcode}
                                            </Box>
                                        )}
                                        loading={locations.length > 0}
                                        inputValue={province || ''}
                                        onInputChange={(event, newInputValue) => {
                                            setProvince(newInputValue);
                                        }}
                                        value={value || null}
                                        onChange={(event, newValue) => {
                                            setValue(newValue)
                                            // setValueD(newValue)
                                        }}
                                        onBlur={e => {
                                            if (!e.target.value) {
                                                setProvinceError(true)
                                            } else {
                                                setProvinceError(false)
                                            }
                                        }}
                                        renderInput={(params) => (
                                            <Box className={`backgroundField ${province.length === 0 && provinceError ? 'error' : ''}`} ref={params.InputProps.ref}>
                                                <Input type="text" {...params.inputProps} disableUnderline />

                                            </Box>
                                        )} />
                                    {province.length === 0 && provinceError && <span style={{ color: 'red', fontSize: '12px', }}>กรุณากรอกจังหวัด</span>}

                                </div>
                                <div class="col-lg-4 col-md-12">
                                    <label class="labelInput">รหัสไปรษณีย์</label>
                                    <Autocomplete
                                        fullWidth
                                        options={locations || []}
                                        getOptionLabel={(option) => option?.Zipcode}
                                        renderOption={(props, option) => (
                                            <Box component="li" {...props} key={option.SubDistrictId}>
                                                จ.{option?.ProvinceName} / อ.{option?.DistrictName} / ต.{option?.SubDistrictName} / {option?.Zipcode}
                                            </Box>
                                        )}
                                        loading={locations.length > 0}
                                        inputValue={zipcode || ''}
                                        onInputChange={(event, newInputValue) => {
                                            setZipcode(newInputValue);
                                        }}
                                        value={value || null}
                                        onChange={(event, newValue) => {
                                            setValue(newValue)
                                            // setValueD(newValue)
                                        }}
                                        onBlur={e => {
                                            if (!e.target.value) {
                                                setZipcodeError(true)
                                            } else {
                                                setZipcodeError(false)
                                            }
                                        }}
                                        onKeyPress={(event) => {
                                            if (!/[0-9]/.test(event.key)) {
                                                event.preventDefault();
                                            }
                                        }}
                                        renderInput={(params) => (
                                            <Box className={`backgroundField ${zipcode.length === 0 && zipcodeError ? 'error' : ''}`} ref={params.InputProps.ref}>
                                                <Input type="text" {...params.inputProps} disableUnderline />

                                            </Box>
                                        )}
                                    />
                                    {zipcode.length === 0 && zipcodeError && <span style={{ color: 'red', fontSize: '12px', }}>กรุณากรอกรหัสไปรษณีย์</span>}
                                </div>


                            </div>


                            <hr class="chr" />
                            {customerTypeNo === 'CT01' || customerTypeNo === 'CT06' ?
                                <>
                                    <div class="d-flex row align-items-center">
                                        <div class="col-6">
                                            <label class="title-content mb-4 me-5">
                                                ที่อยู่ปัจจุบัน
                                            </label>
                                            <FormControlLabel control={<Checkbox onChange={e => {
                                                if (e.target.checked === true) {
                                                    setValueC(value)
                                                    setCurrentHouseNumber(houseNumber)
                                                    setCurrentMoo(moo)
                                                    setCurrentAlley(alley)
                                                    setCurrentAddress(address)
                                                } else {
                                                    setValueC()
                                                    setCurrentHouseNumber('')
                                                    setCurrentMoo('')
                                                    setCurrentAlley('')
                                                    setCurrentAddress('')
                                                }
                                            }} />} label="ที่อยู่ตามบัตรประชาชน" />

                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-4 col-md-12">
                                            <label class="labelInput">บ้านเลขที่</label>
                                            <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                                <TextField value={currentHouseNumber} onChange={e => setCurrentHouseNumber(e.target.value)} variant="standard" fullWidth
                                                    InputProps={{
                                                        disableUnderline: true,
                                                    }}
                                                />
                                            </Box>

                                        </div>
                                        <div class="col-lg-4 col-md-12">
                                            <label class="labelInput">หมู่</label>
                                            <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                                <TextField value={currentMoo} onChange={e => setCurrentMoo(e.target.value)} variant="standard" fullWidth
                                                    InputProps={{
                                                        disableUnderline: true,
                                                    }}
                                                    onKeyPress={(event) => {
                                                        if (!/[0-9]/.test(event.key)) {
                                                            event.preventDefault();
                                                        }
                                                    }}
                                                />
                                            </Box>
                                        </div>


                                    </div>
                                    <div class="row">
                                        <div class="col-lg-4 col-md-12">
                                            <label class="labelInput">ตรอก/ซอย</label>
                                            <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                                <TextField value={currentAlley} onChange={e => setCurrentAlley(e.target.value)} variant="standard" fullWidth
                                                    InputProps={{
                                                        disableUnderline: true,
                                                    }}
                                                />
                                            </Box>
                                        </div>
                                        <div class="col-lg-4 col-md-12">
                                            <label class="labelInput">ถนน</label>
                                            <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                                <TextField value={currentAddress} onChange={e => setCurrentAddress(e.target.value)} variant="standard" fullWidth
                                                    InputProps={{
                                                        disableUnderline: true,
                                                    }}
                                                />
                                            </Box>
                                        </div>


                                    </div>

                                    <div class="row">

                                        <div class="col-lg-4 col-md-12">
                                            <label class="labelInput">ตำบล</label>
                                            <Autocomplete
                                                fullWidth
                                                options={locationsC || []}
                                                getOptionLabel={(option) => option?.SubDistrictName}
                                                renderOption={(props, option) => (
                                                    <Box component="li" {...props} key={option.SubDistrictId}>
                                                        จ.{option?.ProvinceName} / อ.{option?.DistrictName} / ต.{option?.SubDistrictName} / {option?.Zipcode}
                                                    </Box>
                                                )}
                                                loading={locationsC.length > 0}
                                                inputValue={currentSubDistrict || ''}
                                                onInputChange={(event, newInputValue) => {
                                                    setCurrentSubDistrict(newInputValue);
                                                }}
                                                value={valueC || null}
                                                onChange={(event, newValue) => {
                                                    setValueC(newValue)
                                                    // setValueD(newValue)
                                                }}

                                                renderInput={(params) => (
                                                    <Box className='backgroundField' sx={{ marginBottom: '10px' }} ref={params.InputProps.ref}>
                                                        <Input type="text" {...params.inputProps} disableUnderline />

                                                    </Box>
                                                )}
                                            />
                                        </div>
                                        <div class="col-lg-4 col-md-12">
                                            <label class="labelInput">อำเภอ</label>
                                            <Autocomplete
                                                fullWidth
                                                options={locationsC || []}
                                                getOptionLabel={(option) => option?.DistrictName}
                                                renderOption={(props, option) => (
                                                    <Box component="li" {...props} key={option.SubDistrictId}>
                                                        จ.{option?.ProvinceName} / อ.{option?.DistrictName} / ต.{option?.SubDistrictName} / {option?.Zipcode}
                                                    </Box>
                                                )}
                                                loading={locationsC.length > 0}
                                                inputValue={currentDistrict || ''}
                                                onInputChange={(event, newInputValue) => {
                                                    setCurrentDistrict(newInputValue);
                                                }}
                                                value={valueC || null}
                                                onChange={(event, newValue) => {
                                                    setValueC(newValue)
                                                    // setValueD(newValue)
                                                }}
                                                renderInput={(params) => (
                                                    <Box className='backgroundField' sx={{ marginBottom: '10px' }} ref={params.InputProps.ref}>
                                                        <Input type="text" {...params.inputProps} disableUnderline />

                                                    </Box>
                                                )}
                                            />
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-4 col-md-12">
                                            <label class="labelInput">จังหวัด</label>
                                            <Autocomplete
                                                fullWidth
                                                options={locationsC || []}
                                                getOptionLabel={(option) => option?.ProvinceName}
                                                renderOption={(props, option) => (
                                                    <Box component="li" {...props} key={option.SubDistrictId}>
                                                        จ.{option?.ProvinceName} / อ.{option?.DistrictName} / ต.{option?.SubDistrictName} / {option?.Zipcode}
                                                    </Box>
                                                )}
                                                loading={locationsC.length > 0}
                                                inputValue={currentProvince || ''}
                                                onInputChange={(event, newInputValue) => {
                                                    setCurrentProvince(newInputValue);
                                                }}
                                                value={valueC || null}
                                                onChange={(event, newValue) => {
                                                    setValueC(newValue)
                                                    // setValueD(newValue)
                                                }}

                                                renderInput={(params) => (
                                                    <Box className='backgroundField' sx={{ marginBottom: '10px' }} ref={params.InputProps.ref}>
                                                        <Input type="text" {...params.inputProps} disableUnderline />

                                                    </Box>
                                                )}
                                            />
                                        </div>
                                        <div class="col-lg-4 col-md-12">
                                            <label class="labelInput">รหัสไปรษณีย์</label>
                                            <Autocomplete
                                                fullWidth
                                                options={locationsC || []}
                                                getOptionLabel={(option) => option?.Zipcode}
                                                renderOption={(props, option) => (
                                                    <Box component="li" {...props} key={option.SubDistrictId}>
                                                        จ.{option?.ProvinceName} / อ.{option?.DistrictName} / ต.{option?.SubDistrictName} / {option?.Zipcode}
                                                    </Box>
                                                )}
                                                loading={locationsC.length > 0}
                                                inputValue={currentZipcode || ''}
                                                onInputChange={(event, newInputValue) => {
                                                    setCurrentZipcode(newInputValue);
                                                }}
                                                value={valueC || null}
                                                onChange={(event, newValue) => {
                                                    setValueC(newValue)
                                                    // setValueD(newValue)
                                                }}
                                                onKeyPress={(event) => {
                                                    if (!/[0-9]/.test(event.key)) {
                                                        event.preventDefault();
                                                    }
                                                }}
                                                renderInput={(params) => (
                                                    <Box className='backgroundField' sx={{ marginBottom: '10px' }} ref={params.InputProps.ref}>
                                                        <Input type="text" {...params.inputProps} disableUnderline />

                                                    </Box>
                                                )}
                                            />
                                        </div>


                                    </div>
                                    <hr class="chr" />
                                </> : null
                            }


                            <div class="row">
                                <div class="col-6">
                                    <label class="title-content mb-4">
                                        ไฟล์ที่แนบมา
                                    </label>
                                </div>
                            </div>

                            <div class="row w-100">
                                <div class="col-12  fixed-width">
                                    <div class="sub-fixed-width">
                                        <label class="labelInput">อัพโหลดสำเนาเอกสาร</label>
                                        <div class="upload-file" style={{ display: 'flex', width: '400px' }}>
                                            <Box className='backgroundField' sx={{ marginBottom: '10px', width: '100%' }}>
                                                <FormControl variant="standard" fullWidth >
                                                    <Select value={typesFileSelected || ''} onChange={e => setTypesFileSelected(e.target.value)} disableUnderline >
                                                        {TypesFileCustomer?.map((x) => (
                                                            <MenuItem value={x?.value}>{x?.name}</MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            </Box>
                                            <input
                                                type="file" ref={fileRef} hidden onChange={uploadFile} />
                                            <Button variant='outlined' onClick={() => fileRef.current.click()}
                                                startIcon={<FontAwesomeIcon icon={faUpload} />}
                                                sx={{ width: '150px', fontSize: '16px', margin: '10px' }}>อัพโหลด</Button>
                                        </div>
                                    </div>
                                </div>


                            </div>

                            <div class="row w-100 g-0" >

                                <div class="col-12  fixed-width">
                                    <div class="row">
                                        {file?.map((x, i) => (
                                            <div class="col-lg-6 col-sm-12">

                                                <div class="files-uploaded me-4 " style={{ display: 'flex', alignItems: "center", padding: "10px" }}>
                                                    <div class="icon-file" style={{ marginRight: '10px' }}>
                                                        <img src={`/${x?.pathImg}`} width='50px' />
                                                    </div>
                                                    <div class="file-info" style={{ width: '100%' }}>
                                                        <div class="file-h1" style={{ fontWeight: '600', fontSize: '16px' }}>
                                                            {x?.typeDoc}
                                                        </div>
                                                        <div class="file-d1" style={{ fontWeight: '500', fontSize: '14px', lineBreak: 'anywhere', paddingRight: '10px' }}>
                                                            {x?.FileName}
                                                        </div>
                                                    </div>
                                                    {x?.UploadFileId && <Button color='secondary' onClick={() => viewFile(x)} variant='contained' sx={{ marginRight: '10px', width: "180px", fontSize: "12px", background: '#fbbe66', ':hover': { background: '#eda844' } }} startIcon={<FontAwesomeIcon icon={faEye} />}>เรียกดู</Button>}
                                                    {x?.UploadFileId && <Button onClick={() => downloadFile(x)} variant='contained' sx={{ marginRight: '10px', width: "180px", fontSize: "12px" }} startIcon={<FontAwesomeIcon icon={faDownload} />} >ดาวน์โหลด</Button>}
                                                    <div class="file-remove" onClick={() => {
                                                        if (x?.UploadFileId) {
                                                            setFilesRemove([...filesRemove, x?.UploadFileId]);
                                                            const remo = file?.filter((y, index) => i !== index)
                                                            setFile(remo)
                                                        } else {
                                                            const remo = file?.filter((y, index) => i !== index)
                                                            setFile(remo)
                                                        }

                                                    }} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '32px', color: 'red', cursor: 'pointer' }}>
                                                        <FontAwesomeIcon icon={faCircleXmark} />
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <hr class="chr" />
                                <div class="row mt-4">

                                    <div class="col-12">

                                        <Button variant='outlined' onClick={() => navigate(-1)} startIcon={<FontAwesomeIcon icon={faArrowLeft} />} sx={{ width: '130px', fontSize: '14px', marginRight: '10px', height: '40px' }}>กลับ</Button>
                                        {detail?.Status !== 'N' && <Button disabled={loadingSubmit} variant='contained' onClick={() => {
                                            if (contactName.length === 0) {
                                                setContactNameError(true)
                                            }
                                            if (customerFName.length === 0) {
                                                setCustomerFNameError(true)
                                            }
                                            if (customerLName.length === 0) {
                                                setCustomerLNameError(true)
                                            }
                                            if (nationalityId.length === 0) {
                                                setNationalityIdError(true)
                                                setNationalityIdErrorText('กรุณากรอกบัตรประจำตัวประชาชน')
                                            }

                                            if (tel.length === 0) {
                                                setTelError(true)
                                            }
                                            if (province.length === 0) {
                                                setProvinceError(true)
                                            }
                                            if (district.length === 0) {
                                                setDistrictError(true)
                                            }
                                            if (subDistrict.length === 0) {
                                                setSubDistrictError(true)
                                            }
                                            if (zipcode.length === 0) {
                                                setZipcodeError(true)
                                            }
                                            if (customerFName.length > 0 && tel.length > 0 && province.length > 0 && district.length > 0 && subDistrict.length > 0 && zipcode.length > 0) {
                                                handleSubmit('Y')
                                            }
                                        }} sx={{ width: '130px', fontSize: '14px', height: '40px' }}> {loadingSubmit ? <CircularProgress size={'18px'} color="inherit" /> : 'บันทึก'}</Button>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </Page>
        </div>
    )
}
